import PropTypes from 'prop-types';
import { TYPES_OF_TRANSACTION, PAYMENT_METHOD } from 'components/common/constants';
import ExchangePaymentDetails from './components/ExchangePaymentDetails';
import CommissionPaymentDetails from './components/CommissionPaymentDetails';
import InternalPaymentDetails from './components/InternalPaymentDetails';
import NormalPaymentDetails from './components/NormalPaymentDetails';
import CryptoPaymentDetails from './components/CryptoPaymentDetails';
import CardPaymentDetails from './components/CardPaymentDetails';

const PaymentDetailsModal = ({
  selectedTransaction,
  amountDetails,
  commissionDetails,
  totalAmountDetails,
  onClose,
  ...otherProps
}) => {
  const getPaymentDetailsComponent = () => {
    // Determine transaction type and return appropriate component
    const transactionType = selectedTransaction?.transaction_type;
    const paymentMethod = selectedTransaction?.payment_method;

    // Card payments
    if (transactionType === TYPES_OF_TRANSACTION.PURCHASE && paymentMethod === PAYMENT_METHOD.CARD) {
      return (
        <CardPaymentDetails
          transaction={selectedTransaction}
          amountDetails={amountDetails}
          commissionDetails={commissionDetails}
          totalAmountDetails={totalAmountDetails}
          onClose={onClose}
          {...otherProps}
        />
      );
    }

    // Exchange transactions
    if (transactionType === TYPES_OF_TRANSACTION.EXCHANGE) {
      return (
        <ExchangePaymentDetails
          transaction={selectedTransaction}
          amountDetails={amountDetails}
          commissionDetails={commissionDetails}
          totalAmountDetails={totalAmountDetails}
          onClose={onClose}
          {...otherProps}
        />
      );
    }

    // Commission transactions
    if (transactionType === TYPES_OF_TRANSACTION.COMMISSION) {
      return (
        <CommissionPaymentDetails
          transaction={selectedTransaction}
          amountDetails={amountDetails}
          commissionDetails={commissionDetails}
          totalAmountDetails={totalAmountDetails}
          onClose={onClose}
          {...otherProps}
        />
      );
    }

    // Internal (between own accounts) transactions
    if (transactionType === TYPES_OF_TRANSACTION.INTERNAL) {
      return (
        <InternalPaymentDetails
          transaction={selectedTransaction}
          amountDetails={amountDetails}
          commissionDetails={commissionDetails}
          totalAmountDetails={totalAmountDetails}
          onClose={onClose}
          {...otherProps}
        />
      );
    }

    // Internal (between own accounts) transactions
    if (
      transactionType === TYPES_OF_TRANSACTION.NORMAL &&
      paymentMethod !== PAYMENT_METHOD.CRYPTO &&
      paymentMethod !== PAYMENT_METHOD.CARD
    ) {
      return (
        <NormalPaymentDetails
          transaction={selectedTransaction}
          amountDetails={amountDetails}
          commissionDetails={commissionDetails}
          totalAmountDetails={totalAmountDetails}
          onClose={onClose}
          {...otherProps}
        />
      );
    }

    // Crypto transactions
    if (transactionType === TYPES_OF_TRANSACTION.NORMAL && paymentMethod === PAYMENT_METHOD.CRYPTO) {
      return (
        <CryptoPaymentDetails
          transaction={selectedTransaction}
          amountDetails={amountDetails}
          commissionDetails={commissionDetails}
          totalAmountDetails={totalAmountDetails}
          onClose={onClose}
          {...otherProps}
        />
      );
    }

    // Default case - use old modal
    return (
      <NormalPaymentDetails
        transaction={selectedTransaction}
        amountDetails={amountDetails}
        commissionDetails={commissionDetails}
        totalAmountDetails={totalAmountDetails}
        onClose={onClose}
        {...otherProps}
      />
    );
  };

  return getPaymentDetailsComponent();
};

PaymentDetailsModal.propTypes = {
  selectedTransaction: PropTypes.object.isRequired,
  amountDetails: PropTypes.object,
  commissionDetails: PropTypes.object,
  totalAmountDetails: PropTypes.object,
  onClose: PropTypes.func.isRequired
};

export default PaymentDetailsModal;
